import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalService, ProfileService, SellerService } from 'src/app/core';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';

@Component({
  selector: 'app-user-access-validation',
  templateUrl: './user-access-validation.component.html',
  styleUrls: ['./user-access-validation.component.scss']
})
export class UserAccessValidationComponent implements OnInit {

  userProfile: any;
  redeemFlag: boolean = false;
  isSalesManager: boolean = false;
  isSeManager: boolean = false;
  pviEligible: boolean = false;

  constructor(
    readonly router: Router,
    readonly sellerService: SellerService,
    readonly profileService: ProfileService,
    readonly popupMessageService: PopupMessageService
  ) {}

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');

    if (
      (this.userProfile.grsUser && this.userProfile.active && !this.userProfile.company.profileComplete) ||
      (this.userProfile.grsUser && !this.userProfile.active && !this.userProfile.onlyRedeemPoints)
    ) {
      this.getPointsAvailable();
    }

    this.findPendingRoles();

    if (this.userProfile.pvieligible === false) {
      this.pviEligible = true;
    }
  }

  getPointsAvailable() {
    this.sellerService.getPointsAvailable().subscribe(
      (data) => {
        if (data.pointsRemaining) {
          this.redeemFlag = true;
        }
      },
      () => {}
    );
  }

  resendVerificationEmail() {
    const lang = localStorage.getItem('selectedLanguage');
    this.profileService.getEmailVerify(this.userProfile.id).subscribe(
      () => {
        this.popupMessageService.showSuccess(this.getLocalizedSuccessMsg(lang), 'success');
      },
      () => {
        this.popupMessageService.showError(this.getLocalizedErrorMsg(lang), 'error');
      }
    );
  }

  findPendingRoles() {
    const salesMngr = 'SALES_MANAGER';
    const seManager = 'SE_MANAGER';
    this.isSalesManager = this.userProfile.hasOwnProperty('userType')
      ? true
      : this.userProfile.pendingRole && this.userProfile.pendingRoles.find((item: any) => item.name === salesMngr);
    this.isSeManager = this.userProfile.hasOwnProperty('userType')
      ? true
      : this.userProfile.pendingRole && this.userProfile.pendingRoles.find((item: any) => item.name === seManager);
  }

  resendApprovalEmail(salesManagerFlag: boolean) {
    const roleName = salesManagerFlag ? 'SALES_MANAGER' : 'SE_MANAGER';
    const roleIndex = this.userProfile.pendingRoles.findIndex((item: any) => item.name === roleName);
    const roleId = this.userProfile.pendingRoles[roleIndex].id;
    const lang = localStorage.getItem('selectedLanguage');

    this.profileService.resendApprovalEmail(this.userProfile.id, roleId).subscribe(
      () => {
        this.popupMessageService.showSuccess(this.getLocalizedSuccessMsg(lang), 'success');
      },
      () => {
        this.popupMessageService.showError(this.getLocalizedErrorMsg(lang), 'error');
      }
    );
  }

  contactSupport() {
    this.router.navigateByUrl('/support');
  }

  private getLocalizedSuccessMsg(lang: string | null): string {
    if (lang === 'Korean') { return '이메일이 성공적으로 전송되었습니다.'; }
    if (lang === 'Japanese') { return 'メールが正常に送信されました。'; }
    return 'Email has been sent successfully.';
  }

  private getLocalizedErrorMsg(lang: string | null): string {
    if (lang === 'Korean') { return '문제가 발생했습니다. 다시 시도하거나 지원 부서에 문의하십시오.'; }
    if (lang === 'Japanese') { return '何かがおかしかった。再試行するか、サポートにお問い합わせください。'; }
    return 'Something went wrong. Please try again or contact support.';
  }
}
